import { configSettingStateServiceKey } from "@smartsheet/config-setting-state-service";
import { diContainer } from "@smartsheet/cufflink";
import logger from "../griddle/Logger";
var ConfigSettingsUtil = /** @class */ (function () {
    function ConfigSettingsUtil() {
    }
    ConfigSettingsUtil.getConfigSettingService = function () {
        try {
            return diContainer.get(configSettingStateServiceKey.name);
        }
        catch (_a) {
            logger.error("[getConfigSettingService] Failed to get configSettingStateService");
            return;
            // ignore - ConfigSettingStateService isn't available
        }
    };
    ConfigSettingsUtil.isConfigSettingBooleanTrue = function (configSettingId) {
        var configSettingStateService = ConfigSettingsUtil.getConfigSettingService();
        if (configSettingStateService) {
            var configSetting = configSettingStateService.getSetting(configSettingId);
            return Boolean(configSetting && configSetting.valueBoolean);
        }
        return false;
    };
    ConfigSettingsUtil.throwIfConfigSettingBooleanIsFalse = function (configSettingId) {
        // This function was created to support feature flag usage
        // We should discuss if we want a hard dependency on the configSettingStateService
        // It seems reasonable that configSettings would be optional; meaning, if there is
        // a configSettingStateService available during runtime we'll use it, but if not
        // just ignore the check and continue.
        // This throws an exception rather than return the valueBoolean of the configSetting
        // because calling this method when it is disabled is a critical exception
        // ...we want things to break in this case
        // Throw error if config setting is disabled (valueBoolean === false)
        // If config setting is not available, ignore and continue
        var configSettingStateService = ConfigSettingsUtil.getConfigSettingService();
        if (configSettingStateService) {
            var configSetting = configSettingStateService.getSetting(configSettingId);
            if (configSetting && !configSetting.valueBoolean) {
                throw Error("Config setting id " + configSettingId + " is disabled - Set config setting in ops-con to True to enable");
            }
        }
    };
    return ConfigSettingsUtil;
}());
export { ConfigSettingsUtil };
//# sourceMappingURL=ConfigSettingsUtil.js.map